import Heading from "../blocks/Heading";

const NotFound = () => {
  return (
    <div className="authentication__top">
      <Heading
        heading="Oops! 404 error..."
        text="Looks like you've lost your flow. This page does not exist."
      />
      <div>
        <a href="/" className="button">
          Return to Homepage
        </a>
      </div>
    </div>
  );
};

export default NotFound;
